import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=74ffff1a&scoped=true&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"
import style0 from "./administrators.vue?vue&type=style&index=0&id=74ffff1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffff1a",
  null
  
)

export default component.exports